module.exports = __webpack_public_path__ + "static/f290a997530a20b964bc502ff54de042.png";